(function() {
    'use strict';

    angular.module('plate.constants', [])
        .constant('plateMessagesConst', {
            delete: 'Płyta została usunięta!',
            add: 'Płyta została dodana!',
            update: 'Dane płyty zostały zaktualizowane!',
            error: 'Wystąpił błąd!',
        })
        .constant('platePermissionsConst', {
            view: {
                value: 'view_plate',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu płyt!'
            },
            add: {
                value: 'add_plate',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania płyt!'
            },
            update: {
                value: 'change_plate',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji płyt!'
            },
            delete: {
                value: 'delete_plate',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania płyt!'
            }
        });
})();
